import { useEffect, useState } from 'react'

import { Table } from 'antd'

import { observer } from 'mobx-react'

import useStore from '@/hooks/useStore'

import './index.less'

const prefix = 'shadeAnalysisResult'
// let drawTool: Draw
function ShadeAnalysisResult() {
  //   const [messageApi, contextHolder] = message.useMessage()
  const shadeAnalysisStore = useStore('shadeAnalysis')
  const [totalpre, settotalpre] = useState('')
  useEffect(() => {
    if (shadeAnalysisStore.shdVals.length > 0) {
      const originvalue = [15, 25, 35, 45, 55, 65, 75, 85, 95]

      let totalcurr = 0
      shadeAnalysisStore.shdVals.forEach((item, index) => {
        const rate = Number.parseFloat(item.rate)
        totalcurr += (originvalue[index] * rate) / 100
      })
      settotalpre(totalcurr.toFixed(2))
    }
    return () => {
      shadeAnalysisStore.clearSimple()
    }
  }, [])
  const columns: Array<any> = [
    {
      title: '구분',
      dataIndex: 'range',
      align: 'center',
      key: 'range',
    },
    {
      title: '색상표',
      dataIndex: 'color',
      align: 'center',
      width: 72,
      key: 'color',
      render: (_: any, record: any) => {
        return (
          <div
            style={{ width: '60px', height: '24px', background: record.color }}
          ></div>
        )
      },
    },
    {
      title: '구성비(%)',
      align: 'center',
      dataIndex: 'rate',
      key: 'rate',
    },
  ]
  return (

    <div className={`${prefix}`}>
      <div className={`${prefix}-txt`}>
        시점 지정
      </div>
      <div className={`${prefix}-info`}>
        <div className={`${prefix}-info-li`}>
          <div className={`${prefix}-info-li-li1`}>
            <div className={`${prefix}-info-li-li1-label`}>주소</div>
            <div className={`${prefix}-info-li-li1-data`}>{shadeAnalysisStore.address}</div>
          </div>

        </div>
        <div className={`${prefix}-info-li`}>
          <div className={`${prefix}-info-li-li1`}>
            <div className={`${prefix}-info-li-li1-label`}>분석 날짜</div>
            <div className={`${prefix}-info-li-li1-data`}>{shadeAnalysisStore.dateData}</div>
          </div>
          <div className={`${prefix}-info-li-li1`}>
            <div className={`${prefix}-info-li-li1-label`}>분석 시간</div>
            <div className={`${prefix}-info-li-li1-data`}>{shadeAnalysisStore.startTime}-{shadeAnalysisStore.endTime}</div>
          </div>
        </div>
        <div className={`${prefix}-info-li`}>
          <div className={`${prefix}-info-li-li1`}>
            <div className={`${prefix}-info-li-li1-label`}>평균음영율</div>
            <div className={`${prefix}-info-li-li1-data`}>{totalpre}</div>
          </div>
        </div>
      </div>
      <div className={`${prefix}-txt`}>
        상세 분석결과
      </div>
      <div className={`${prefix}-tablediv`}>
        <Table size="small" dataSource={shadeAnalysisStore.shdVals} columns={columns} pagination={false} />
      </div>
    </div>

  )
}

export default observer(ShadeAnalysisResult)
